import sortArray from 'utils/arrays/sortedArray.util';
import fromObjectToEntries from 'utils/converters/object/fromObjectToEntries.util';
import compareEntries from 'utils/objects/compareEntries.util';
import isEntryNotSame from 'utils/predicates/object/isEntryNotSame.util';

const isObjectShallowEqual = (a, b) => {
  if (a === b) return true;

  const entriesA = sortArray(compareEntries, fromObjectToEntries(a ?? {}));
  const entriesB = sortArray(compareEntries, fromObjectToEntries(b ?? {}));

  if (entriesA.length !== entriesB.length) return false;

  for (let i = 0; i < entriesA.length; i += 1) {
    if (isEntryNotSame(entriesA[i], entriesB[i])) return false;
  }

  return true;
};

export default isObjectShallowEqual;
